import { Twitter, Send } from 'lucide-react';
import { trackEvent } from '@/lib/analytics';

const CA = import.meta.env.VITE_CONTRACT_ADDRESS || 'TBA';
const TWITTER = import.meta.env.VITE_TWITTER_URL || 'https://x.com/honeybadgercoin';
const TELEGRAM = import.meta.env.VITE_TELEGRAM_URL || 'https://t.me/honeybadgercoin';

export default function Footer() {
  const copyCA = async () => {
    if (!CA || CA === 'TBA') return;
    await navigator.clipboard.writeText(CA);
    trackEvent('contract_copy', { location: 'footer' });
  };

  return (
    <footer className="relative py-20 px-6" style={{ borderTop: '1px solid rgba(212,175,55,0.08)' }}>
      <div className="section-content text-center">
        <div className="text-5xl mb-5">🦡</div>
        <p className="text-title font-black mb-1 text-gold">HONEY BADGER</p>
        <p className="text-caption mb-8" style={{ color: '#555555' }}>Honey Badger Don't Care.</p>

        {/* CA */}
        <button onClick={() => { void copyCA(); }} className="font-mono text-xs mb-8 tracking-widest transition-colors break-all max-w-full" style={{ color: 'rgba(255,255,255,0.15)' }}>
          {CA}
        </button>

        {/* Socials */}
        <div className="flex items-center justify-center gap-6 sm:gap-8 mb-14">
          {[
            { href: TWITTER,  icon: Twitter },
            { href: TELEGRAM, icon: Send    },
          ].map(({ href, icon: Icon }, i) => (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('social_click', { location: 'footer', icon: i })}
              className="transition-colors duration-200 flex items-center justify-center"
              style={{ color: '#333333', width: 44, height: 44 }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#D4AF37'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#333333'; }}
            >
              <Icon size={18} />
            </a>
          ))}
        </div>

        <p className="text-label" style={{ color: 'rgba(255,255,255,0.08)' }}>
          © 2026 Honey Badger. DYOR. Not financial advice. Honey Badger literally doesn't care.
        </p>
      </div>
    </footer>
  );
}
